import { InjectionToken, Type } from '@angular/core';
import { LOYALTY_STATUS } from '@fgb/core';
import { ComingSoonRewardStatusComponent } from './statuses/coming-soon-reward-status/coming-soon-reward-status.component';
import { LimitReachedRewardStatusComponent } from './statuses/limit-reached-reward-status/limit-reached-reward-status.component';
import { LockedRewardStatusComponent } from './statuses/locked-reward-status/locked-reward-status.component';
import { NotEnoughPointsRewardStatusComponent } from './statuses/not-enough-points-reward-status/not-enough-points-reward-status.component';
import { SoldOutRewardStatusComponent } from './statuses/sold-out-reward-status/sold-out-reward-status.component';
export type RewardStatusComponentMap = Record<LOYALTY_STATUS, Type<any> | undefined>;

export const REWARD_STATUS_COMPONENTS = new InjectionToken<RewardStatusComponentMap>('REWARD_STATUS_COMPONENTS', {
  providedIn: 'root',
  factory: () => DefaultComponentMap,
});

export function mergeRewardStatusComponentMaps(partialOverride: Partial<RewardStatusComponentMap>): RewardStatusComponentMap {
  return { ...DefaultComponentMap, ...partialOverride };
}

const DefaultComponentMap: RewardStatusComponentMap = {
  [LOYALTY_STATUS.LOCKED]: LockedRewardStatusComponent,
  [LOYALTY_STATUS.NONE]: undefined,
  [LOYALTY_STATUS.FEATURED]: undefined,
  [LOYALTY_STATUS.NEW]: undefined,
  [LOYALTY_STATUS.STOCK_LOW]: undefined,
  [LOYALTY_STATUS.LIMITED_STOCK]: undefined,
  [LOYALTY_STATUS.COMING_SOON]: ComingSoonRewardStatusComponent,
  [LOYALTY_STATUS.NOT_ENOUGH_POINTS]: NotEnoughPointsRewardStatusComponent,
  [LOYALTY_STATUS.LIMIT_REACHED]: LimitReachedRewardStatusComponent,
  [LOYALTY_STATUS.SOLD_OUT]: SoldOutRewardStatusComponent,
};
